<div class="tracking">
    <div class="tracking__wrapper">
        <div class="tracking__row">
            <dp-trk-status [first]="true" [active]="true" [title]="'Solicitação aberta'" [index]="1"></dp-trk-status>

            <div class="status-separator"></div>

            <!-- <dp-trk-status
                [active]="(isApproved || isPending || isRejected) && !isOpen"
                [title]="'Analisando informações'"
                [index]="2"
            ></dp-trk-status> -->
            <dp-trk-status
            [active]="true"
            [title]="'Analisando informações'"
            [index]="2"
        ></dp-trk-status>

            <div class="status-separator"></div>

            <!-- <dp-trk-status
                [last]="true"
                [active]="isApproved || isRejected"
                [title]="isRejected ? 'Atualização não concluída' : 'Atualização concluída'"
                [index]="3"
                [type]="isRejected ? 'danger' : 'success'"
            ></dp-trk-status> -->
            <dp-trk-status
            [active]="true"
            [title]="'Analisando informações'"
            [index]="2"
        ></dp-trk-status>
        </div>
    </div>
</div>
